import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CustomButton from "../Common/CustomButton";
import InputText from "../sectioninput/formelement/InputText";
import _ from "lodash";
import { updatePartenaire } from "../../REDUX/actions/partenaire";
import { Form } from "react-bootstrap";
const PartenaireForm = ({ marker, partenaireItem }) => {
  const dispatch = useDispatch();

  const [partenaireInputs, setpartenairesInputs] = useState(
    _.omit(partenaireItem.attributes, [
      "locale",
      "createdAt",
      "updatedAt",
      "seo",
      "banner",
      "list",
      "adress",
      "photos_magasin",
      "products",
      "events",
    ])
  );
  const [adressData, setadressData] = useState(
    _.omit(partenaireItem.attributes.adress.data.attributes, [
      "locale",
      "createdAt",
      "updatedAt",
      "seo",
      "logement",
      "event",
      "revendeur",
    ])
  );
  useEffect(() => {
    setpartenairesInputs(
      _.omit(partenaireItem.attributes, [
        "locale",
        "createdAt",
        "updatedAt",
        "seo",
        "banner",
        "list",
        "adress",
        "photos_magasin",
        "products",
        "events",
      ])
    );
    setadressData(
      _.omit(partenaireItem.attributes.adress.data.attributes, [
        "locale",
        "createdAt",
        "updatedAt",
        "seo",
        "event",
        "logement",
        "revendeur",
        "partenaire",
      ])
    );
  }, [partenaireItem]);

  const handlePartenaireChange = (value, champs) => {
    setpartenairesInputs({ ...partenaireInputs, [champs]: value });
  };

  const handleAdressChange = (value, champs) => {
    setadressData({ ...adressData, [champs]: value });
  };

  const handleUpdateAdress = () => {
    dispatch(
      updatePartenaire(
        partenaireItem.id,
        partenaireInputs,
        partenaireItem.attributes.adress.data.id,
        {
          ...adressData,
          coordinates: [marker.getLngLat().lng, marker.getLngLat().lat],
        }
      )
    );
  };
  return (
    <>
      <div className="mt-2">
        <InputText
          labelinput="nom"
          handleChange={handlePartenaireChange}
          champs="name"
          value={partenaireInputs.name}
        />
        <div className="text-start my-2">
          <label className="f16 ">Catégorie</label>
          <div className="d-flex align-items-center gap-2 my-1">
            <div className={`flagInput rounded-3 invisible`}></div>
            <Form.Select
              onChange={(e) =>
                setpartenairesInputs({
                  ...partenaireInputs,
                  partenaire_type: e.target.value,
                })
              }
              defaultValue={partenaireInputs.partenaire_type}
            >
              <option value={"Assureur"}>Assureur</option>
              <option value={"Cuisiniste"}>Cuisiniste</option>
              <option value={"Courtier bancaire"}>Courtier bancaire</option>
              <option value={"Novanéa finance"}>Novanéa finance</option>
            </Form.Select>
          </div>
        </div>
        <InputText
          labelinput="Descrption"
          textArea
          handleChange={handlePartenaireChange}
          champs="description"
          value={partenaireInputs.description}
        />

        <InputText
          labelinput="Site Web"
          handleChange={handlePartenaireChange}
          champs="website"
          value={partenaireInputs.website}
        />
        <InputText
          labelinput="Téléphone"
          handleChange={handlePartenaireChange}
          champs="phoneNumber"
          value={partenaireInputs.phoneNumber}
        />
        <InputText
          labelinput="E-mail"
          handleChange={handlePartenaireChange}
          champs="email"
          value={partenaireInputs.email}
        />
        <InputText
          labelinput="Jours d'ouverture"
          handleChange={handlePartenaireChange}
          champs="openDates"
          value={partenaireInputs.openDates}
        />
        <InputText
          labelinput="Horaire d'ouverture"
          handleChange={handlePartenaireChange}
          champs="openTime"
          value={partenaireInputs.openTime}
        />
      </div>
      <div className="row mb-5">
        <div className="col-12">
          <InputText
            labelinput="Adresse compléte"
            handleChange={handleAdressChange}
            champs="fullAdress"
            value={adressData.fullAdress}
          />
          <InputText
            labelinput="Code Postal"
            handleChange={handleAdressChange}
            champs="postalCode"
            value={adressData.postalCode}
          />
          <InputText
            labelinput="Ville"
            handleChange={handleAdressChange}
            champs="city"
            value={adressData.city}
          />
          <InputText
            labelinput="Pays"
            handleChange={handleAdressChange}
            champs="country"
            value={adressData.country}
          />
        </div>
      </div>
      <CustomButton
        buttonText={"Enregistrer"}
        iconStart={"pencil-fill"}
        callBack={handleUpdateAdress}
        disabled={
          !partenaireInputs.name ||
          !partenaireInputs.description ||
          !adressData.fullAdress
        }
      />
    </>
  );
};

export default PartenaireForm;
